<template>
  <div style="height:100%">
    <Button
      v-if="infoCtrl && editState" class="add-btn"
      style="  margin-left:550px ; float: left;"
      type="primary" @click="getSummonsInfo('edit')"
    >修改</Button>
    <Form
      v-if="!infoCtrl" ref="formValidate"
      class="case-form" :disabled="caseState=='TN'"
      :model="formValidate" :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="开庭时间" prop="courtTime">
        <DatePicker
          v-autoFill="autoFill.courtTime" :value="formValidate.courtTime"
          style="width:100%" type="date"
          placeholder="请填写开庭时间" @on-change="getCourtTime"
        />
      </FormItem>
      <FormItem label="开庭法院" prop="courtAddress">
        <!--        <span v-if="prevCode!='JT_BB' && formValidate.courtAddress">{{ formValidate.courtAddress }}</span>-->
        <mySelect
          ref="courtSelect"
          :path="'/report/courts'"
          :placeholder="'请选择管辖法院'"
          :placeholder-input="'请输入管辖法院'"
          :default-obj="defaultCourt"
          :key-name="'name'"
          :is-load="false"
          @getValue="getCourtId"
        />
      </FormItem>
      <Row>
        <Col span="12">
          <FormItem
            label="审判长" prop="presidingJudge"
            :rules="nameLength"
          >
            <Input
              v-model="formValidate.presidingJudge" v-autoFill="autoFill.presidingJudge"
              placeholder="姓名" @on-change="judgerChange"
            />
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem
            :label-width="10" prop="presidingJudgePhone"
            :rules="formValidate.presidingJudgePhone?isCorrectPhone:{}"
          >
            <Input v-model="formValidate.presidingJudgePhone" placeholder="联系方式" />
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem
            label="助理" prop="assistant"
            :rules="nameLength"
          >
            <Input v-model="formValidate.assistant" placeholder="姓名" />
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem
            :label-width="10" prop="assistantPhone"
            :rules="formValidate.assistantPhone?isCorrectPhone:{}"
          >
            <Input v-model="formValidate.assistantPhone" placeholder="联系方式" />
          </FormItem>
        </Col>
      </Row>
      <FormItem label="传票附件" prop="attachmentList">
        <file-upload
          :default-list="defaultList || []"
          :upload-config="uploadConfig"
          @getFileList="getAttachmentList"
        />
      </FormItem>
      <Row class="detail-btn-box">
        <Button
          type="primary" style="margin-right:10px;"
          :disabled="isSubmit" @click="submit"
        >保存</Button>
        <Button @click="getSummonsInfo()">取消</Button>
      </Row>
    </Form>
    <Row v-if="infoCtrl" class="detail-content">
      <Row><Col span="5" class="left-label">开庭时间：</Col><Col span="16" class="right-content">{{ summonsInfo.courtTimeStr }}</Col></Row>
      <Row><Col span="5" class="left-label">开庭法院：</Col><Col span="16" class="right-content">{{ summonsInfo.courtAddress }}</Col></Row>
      <Row v-if="summonsInfo.presidingJudge"><Col span="5" class="left-label">审判长：</Col><Col span="16" class="right-content">{{ summonsInfo.presidingJudge }}---{{ summonsInfo.presidingJudgePhone }}</Col></Row>
      <Row v-if="summonsInfo.assistant"><Col span="5" class="left-label">助理：</Col><Col span="16" class="right-content">{{ summonsInfo.assistant }}---{{ summonsInfo.assistantPhone }}</Col></Row>
      <Row>
        <Col span="5" class="left-label">传票附件：</Col>
        <Col span="16" class="right-content">
          <file-upload
            :default-list="summonsInfo.attachmentList || []"
            :upload-config="{readOnly:true}"
          />
        </Col>
      </Row>
    </Row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import getQccKeyData from '@/libs/qcc.js'
export default {
  components: {},
  props: ['processId', 'caseId', 'editState', 'prevCode', 'caseState'],
  data () {
    return {
      editId: '',
      formValidate: {
        courtTime: '',
        courtAddress: '',
        presidingJudge: '',
        presidingJudgePhone: '',
        assistant: '',
        assistantPhone: '',
        attachmentList: []
      },
      ruleValidate: {
        courtTime: [{ required: true, message: '开庭时间不能为空', trigger: 'change' }],
        courtAddress: [{ required: true, message: '开庭法院不能为空', trigger: 'change' }],
        attachmentList: [{ required: true, type: 'array', message: '附件不能为空', trigger: 'blur' }]
      },
      isCorrectPhone: [{ message: '联系方式格式不正确', pattern: /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/, trigger: 'blur' }],
      nameLength: [{ max: 32, message: '长度不能超过32个字符', trigger: 'blur' }],
      uploadConfig: {
        fileName: ''
      },
      defaultList: [],
      isSubmit: false,
      infoCtrl: false,
      defaultCourt: {},
      caseDetail: '',
      hasDetail: false,
      isDetailLoad: false,
      autoFill: {
        courtTime: false,
        presidingJudge: false
      }
    }
  },
  computed: {
    ...mapGetters(['qccData']),
    qccWatch() {
      return {
        isDetailLoad: this.isDetailLoad,
        hasData: !!this.qccData.length
      }
    }
  },
  watch: {
    qccWatch: {
      handler: async function(value) {
        if (value.isDetailLoad && value.hasData && !this.hasDetail && !this.infoCtrl) {
          this.formValidate.courtTime = await getQccKeyData(this.qccData, 'courtTime')
          this.autoFill.courtTime = !!this.formValidate.courtTime
          this.formValidate.presidingJudge = await getQccKeyData(this.qccData, 'presidingJudge')
          this.autoFill.presidingJudge = !!this.formValidate.presidingJudge
        }
      },
      deep: true
    }

  },
  created() {},
  beforeMount() {},
  mounted() {
    // this.getCourt();
    this.getSummonsInfo()
    this.getCaseDetail()
  },
  updated() {},
  methods: {
    // 获取案件详情(用于得知该案件是一审还是二审)
    getCaseDetail() {
      const url = '/business/case/' + this.caseId + '/lawyer'
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.caseDetail = res.data
          if (this.prevCode != 'JT_BB') {
            this.getCourt()
          }
        }
      })
    },
    // 获取受理法院
    getCourt() {
      const url = '/business/case/court/lawyer?caseId=' + this.caseId
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.formValidate.courtAddress = res.data
          this.defaultCourt = {
            name: res.data
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getCourtId(data) {
      this.formValidate.courtAddress = data.name
    },
    getCourtTime(value) {
      this.formValidate.courtTime = value
      if (this.autoFill.courtTime) this.autoFill.courtTime = false
    },
    judgerChange() {
      if (this.autoFill.presidingJudge) this.autoFill.presidingJudge = false
    },
    // 获取图片列表
    getAttachmentList (arr) {
      this.formValidate.attachmentList = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidate.attachmentList.push(obj)
      })
    },
    submit() {
      this.$refs['formValidate'].validate((vaild) => {
        if (vaild) {
          this.isSubmit = true
          const url = '/business/case/summons'
          const ajaxData = {}
          Object.assign(ajaxData, this.formValidate)
          ajaxData.processId = this.processId
          ajaxData.caseId = this.caseId
          if (this.editId) {
            ajaxData.id = this.editId
            this.$patch(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
              this.isSubmit = false
              this.getSummonsInfo()
            })
          } else {
            this.$post(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
              this.isSubmit = false
              this.getSummonsInfo()
            })
          }
        }
      })
    },
    // 获取传票详情
    getSummonsInfo(type) {
      const url = '/business/case/summons/' + this.processId
      this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          this.summonsInfo = res.data
          this.$emit('getAuditState', true)
          this.infoCtrl = type !== 'edit'
          if (type == 'edit') {
            this.getDetail(this.summonsInfo)
          }
          this.hasDetail = true
        } else {
          this.$emit('getAuditState', false)
          this.infoCtrl = false
          this.hasDetail = false
        }
        this.isDetailLoad = true
      })
    },
    // 赋值
    getDetail(value) {
      const data = JSON.parse(JSON.stringify(value))
      this.editId = data.id
      for (const key in this.formValidate) {
        this.formValidate[key] = data[key]
      }
      this.formValidate.courtTime = data.courtTimeStr
      this.defaultList = data.attachmentList.length > 0 ? data.attachmentList.map(item => {
        return {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
      }) : []
      this.formValidate.attachmentList = this.defaultList
      this.formValidate.courtAddress = data.courtAddress
      this.defaultCourt = {
        name: data.courtAddress
      }
      this.$nextTick(() => {
        this.$refs.courtSelect.voluation()
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '../caseCommon.scss';
.add-btn{
    margin-top:-64px;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/pretrial/summons.vue